import React from 'react'
import { Badge } from 'react-bootstrap'
import classnames from 'classnames'
import _ from 'lodash'

import CustomTooltip from './custom_tooltip'

const PricingToggle = ({
  ontoggle,
  selectedToggle,
  tabGroups
}) => {
  return (
    <div className='d-flex flex-column'>
      <div className='product-toggle'>
        {
          _.sortBy(tabGroups, 'order').map(({
            name: value,
            display: {
              name: label,
              badge,
              badge_txt: badgeValue,
              badge_tooltip: tooltipText
            }
          }, idx) => {

            return (
              <div
                key={idx}
                className={classnames('product-toggle__option', { selected: selectedToggle === value })}
                onClick={() => ontoggle(value)}
                onKeyDown={() => ({})}
                role='tab'
                tabIndex={-1}
              >
                <span className="product-toggle__option-text">{label}</span>
                {
                  badge && (
                    <CustomTooltip
                      tootipId={`tooltip-${idx}`}
                      tooltipText={tooltipText}
                    >
                      <Badge
                        className="product-toggle__option-discount"
                        data-tip={tooltipText}
                        data-for={`tooltip-${idx}`}
                      >
                        {badgeValue}
                      </Badge>
                    </CustomTooltip>
                  )
                }
                {
                  label === 'One Time' && (
                    <span className="product-toggle__oneTime">
                      {badgeValue}
                    </span>
                  )
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}

export default PricingToggle
